<template>
    <div>
        <slot :active-block="activeBlock" :set-active-block="setActiveBlock" />
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const activeBlock = ref(null);

    const setActiveBlock = block => {
        if (activeBlock.value === block) {
            activeBlock.value = null;
        } else {
            activeBlock.value = block;
        }
    };
</script>
